module.exports = __webpack_public_path__ + "static/media/hand-with-coin.063299b4.png";